import { User } from '../user/user.model';

export enum WorkTaskStatus {
  ToDo = 0,
  InProgress = 1,
  Done = 2,
  Cancelled = 3,
}

export enum WorkTaskPriority {
  Low = 0,
  Medium = 1,
  High = 2,
  Urgent = 3,
}

export interface WorkTask {
  id: string;
  created?: Date;
  title: string;
  description?: string;
  status: WorkTaskStatus;
  priority: WorkTaskPriority;
  sortOrder: number;
  projectId?: string;
  projectName?: string;
  workUnitId?: string;
  workUnitName?: string;
  week?: string;
  assignedEmployees: User[];
}

export interface WorkTaskFormModel extends Omit<WorkTask, 'assignedEmployees'> {
  assignedEmployeeIds: string[];
}
